import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class StoreUserModel {
    private static sInstance: StoreUserModel;

    public static get instance(): StoreUserModel {
        if (!StoreUserModel.sInstance) {
            StoreUserModel.sInstance = new StoreUserModel();
        }

        return StoreUserModel.sInstance;
    }

    private storeUserList = TCBReceiptApi.Protobuf.StoreUserList.create();
    private specificStoreUser = TCBReceiptApi.Protobuf.StoreUser.create();

    public async getStoreUser(storeUserQuery: Uint8Array): Promise<void> {
        await Network.sendAPI("/api/front/store_user/get_by_tid_number", "post", storeUserQuery)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeUserList = TCBReceiptApi.Protobuf.StoreUserList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });
    }

    public async getStoreUserByCondition(
        storeUserQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/store_user/get_by_condition",
            "post",
            storeUserQuery
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeUserList = TCBReceiptApi.Protobuf.StoreUserList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });
    }

    public async getById(
        storeUserQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/store_user/get_by_store_user_id",
            "post",
            storeUserQuery
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.specificStoreUser = TCBReceiptApi.Protobuf.StoreUser.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });
    }

    public async addStoreUser(
        storeUser: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI("/api/front/store_user/add", "post", storeUser)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async editStoreUser(
        storeUser: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI("/api/front/store_user/edit", "post", storeUser)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async deleteStoreUser(
        storeUser: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI("/api/front/store_user/delete", "post", storeUser)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async resetPassword(
        storeUser: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI("/api/front/store_user/reset_password", "post", storeUser)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public getStoreUserList(): TCBReceiptApi.Protobuf.StoreUserList {
        return this.storeUserList;
    }

    public getSpecificStoreUser(): TCBReceiptApi.Protobuf.StoreUser {
        return this.specificStoreUser;
    }

    public async getPermissionMap(
        StoreUserQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.StoreUserPermissionList> {
        let list = TCBReceiptApi.Protobuf.StoreUserPermissionList.create();

        await Network.sendAPI(
            "/api/front/store_user/get_select_map",
            "post",
            StoreUserQuery
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                list = TCBReceiptApi.Protobuf.StoreUserPermissionList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });

        return list;
    }

    public async changePassword(
        passwordMotify: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.ErrorCode> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI(
            "/api/front/store_user/change_password",
            "post",
            passwordMotify
        )
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async getStoreUserByAccountAndIdentification(
        frontCredentials: Uint8Array
    ): Promise<[TCBReceiptApi.Protobuf.ErrorCode, TCBReceiptApi.Protobuf.StoreUser]> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;
        let storeUser = TCBReceiptApi.Protobuf.StoreUser.create();

        await Network.sendAPI("/api/web_user/get_by_account_and_identification", "post", frontCredentials)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                ec = response.errorCode;
                storeUser = TCBReceiptApi.Protobuf.StoreUser.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch(error => {
                Log.error(error);
            });

        return [ec, storeUser];
    }
}

const storeUserModel = StoreUserModel.instance;

export { storeUserModel as StoreUserModel };
